var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { cachedSet } from '../../../utils/utils';
import { uniq } from '../../../utils/helper/lodash_replacements';
export class ActorBundles {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get actor() {
        return this.parent;
    }
    get bundleModel() {
        return this.actor.model;
    }
    get activeBundles() {
        return this.loadedBundles.filter((b) => !!b);
    }
    get loadedBundles() {
        return this.activeBundleIds
            .filter((id) => id !== this.actor.id)
            .map((bundleId) => this.bundleModel.stream.bundle[bundleId])
            .filter((b) => typeof b !== 'undefined');
    }
    get attachedBundles() {
        return this.attachedBundleIds
            .map((bundleId) => this.bundleModel.stream.bundle[bundleId])
            .filter((b) => !!b);
    }
    get areDirectActiveBundleChildrenAvailable() {
        return this.activeBundleIds.length <= this.loadedBundles.length;
    }
    get nativeBundleIds() {
        const bundleIds = [];
        if (this.actor.type === 'question')
            bundleIds.push(this.actor.layout);
        if (this.actor.type === 'app') {
            bundleIds.push('BJxqw82DNe'); // Global_
            if (this.actor.context.app.stage.stageTypeInfo.isAbfragerStage) {
                bundleIds.push('SkW1e0bdZ'); // Stage_Abfrager_
            }
            else {
                bundleIds.push('rJnlnGDBf'); // Stage Draft_
            }
        }
        if (this.actor.type === 'bundle') {
            const bundleName = this.actor.name;
            if (bundleName.includes('Associate_layout'))
                bundleIds.push('QstMaC0xo'); // Questiontype_Associate_
            if (bundleName.includes('MultipleChoice_layout'))
                bundleIds.push('mnWSz2Pvf'); // Questiontype_MultipleChoice_
            if (bundleName.includes('Read_layout'))
                bundleIds.push('UOwQNg71d');
            if (bundleName.includes('KnowAWord_layout'))
                bundleIds.push('AiUgZNpfD');
            if (bundleName.includes('MemorizePoints_layout'))
                bundleIds.push('tbuItKn3M');
            if (bundleName.includes('CorrectWrong_layout'))
                bundleIds.push('mXCVzxwEz');
            if (bundleName.includes('CycleEnd_layout'))
                bundleIds.push('TdXsTM523');
            if (bundleName.includes('OrderedChoice_layout'))
                bundleIds.push('yPPpcc_fZ');
            if (bundleName.includes('Sortable_layout'))
                bundleIds.push('PV_H35');
            if (bundleName.includes('MultiSelect_layout'))
                bundleIds.push('BJjWnLGpe');
            if (bundleName.includes('Intro_layout'))
                bundleIds.push('hBAauf');
            if (bundleName.includes('Talk_layout'))
                bundleIds.push('NZUUl9');
        }
        return bundleIds;
    }
    get activeBundleIds() {
        const active = this.activeBundleTraits.map((ab) => ab.value);
        return uniq(active.concat(this.nativeBundleIds)).filter((id) => !!id);
    }
    get attachedBundleIds() {
        const attached = this.attachedImportTraits.map((ab) => ab.trait.value);
        return uniq(attached.concat(this.nativeBundleIds)).filter((id) => !!id);
    }
    get preloadBundleIds() {
        const preload = this.attachedImportTraits
            .filter((at) => {
            const preloadSetting = at.trait.local.valueOf.preloadBundle;
            if (preloadSetting === 'force_preload')
                return true;
            if (preloadSetting === 'disable_preload')
                return false;
            if (preloadSetting === 'preload_if_active')
                return at.attachedActive.isAtActive;
            return true;
        })
            .map((ab) => ab.trait.value);
        return uniq(preload.concat(this.nativeBundleIds));
    }
    get preloadBundles() {
        return this.preloadBundleIds
            .map((bundleId) => this.bundleModel.stream.bundle[bundleId])
            .filter((b) => !!b);
    }
    get deepPreloadBundleIds() {
        return this.preloadBundleIds.concat(...this.preloadBundles.map((bundle) => bundle.actorBundles.deepPreloadBundleIds));
    }
    get deepPreloadBundleNames() {
        return uniq(this.preloadBundles.map((bundle) => bundle.name)).concat(...this.preloadBundles.map((bundle) => bundle.actorBundles.deepPreloadBundleNames));
    }
    get areAllActiveBundlesAvailable() {
        const missingDeepBundles = this.activeBundles.filter((bundle) => !bundle.actorBundles.areAllActiveBundlesAvailable);
        return this.areDirectActiveBundleChildrenAvailable && missingDeepBundles.length === 0;
    }
    get activeBundleTraits() {
        return this.attachedImportTraits.filter((at) => at.attachedActive.isAtEnabled).map((ab) => ab.trait);
    }
    get attachedImportTraits() {
        return this.actor.actorTraits
            .allOwnAttachedTraitsOfKey('importbundle')
            .filter((at) => !at.aspect.aspectInfo.hasExportTrait && at.trait.value);
    }
}
__decorate([
    cachedSet
], ActorBundles.prototype, "loadedBundles", null);
__decorate([
    cachedSet
], ActorBundles.prototype, "attachedBundles", null);
__decorate([
    computed
], ActorBundles.prototype, "areDirectActiveBundleChildrenAvailable", null);
__decorate([
    cachedSet
], ActorBundles.prototype, "activeBundleIds", null);
__decorate([
    cachedSet
], ActorBundles.prototype, "attachedBundleIds", null);
__decorate([
    cachedSet
], ActorBundles.prototype, "deepPreloadBundleNames", null);
__decorate([
    computed
], ActorBundles.prototype, "areAllActiveBundlesAvailable", null);
__decorate([
    cachedSet
], ActorBundles.prototype, "activeBundleTraits", null);
__decorate([
    cachedSet
], ActorBundles.prototype, "attachedImportTraits", null);
